import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

interface ICreateVenueCategoryBody {
  name: string;
  parent_id: string | null;
}
export const createVenueCategory = async (body: ICreateVenueCategoryBody[]) => {
  const res = await fetch(`${API_URL}/venues/categories`, {
    method: 'POST',
    body: JSON.stringify({ categories: body }),
    headers: {
      'Content-Type': 'application/json',
    },
  });
  if (res.status !== Status.CREATED) {
    throw new Error('Unable to create venue category');
  }
};
